<script lang="ts">
    import type { Snippet } from 'svelte';

    interface Props {
        children?: Snippet;
    }

    let { children }: Props = $props();
</script>

<div class="reptile-price__priceAndUVP">
    {@render children?.()}
</div>

<style lang="scss">
    .reptile-price {
        &__priceAndUVP {
            align-items: baseline;
            display: flex;
            flex-flow: row wrap-reverse;
        }
    }
</style>
